import { Component, Inject, OnInit, OnDestroy} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, lastValueFrom, takeUntil} from 'rxjs';
import { DropDownOptions, StoreDropdowns } from '../../models/app-models';
import { Store } from '@ngrx/store';
import { ContractExecutive } from '../../models/database-models';
@Component({
  selector: 'app-ce-dialog',
  templateUrl: './ce-dialog.component.html',
  styleUrls: ['./ce-dialog.component.scss']
})
export class CeDialogComponent implements OnInit, OnDestroy{
  isErr: boolean = false;
  selectedCE: DropDownOptions | null = null;
  defaultErrorMessage: string = 'Please select a CE'
  errorMessage: string = this.defaultErrorMessage;
  CEList: DropDownOptions[] = [];
  mpDocumentNumber: string = '';
  loggedInUsername: string = '';
  workflowId: string = '';
  currentCE: DropDownOptions | null = null;
  CE: string | null | undefined = null;
  isLoading: boolean = false;
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(public dialogInfoRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private BackendApi: BackendApiService,
    private router: Router,
    private _snackBar: MatSnackBar,
    private store: Store<{ dp: StoreDropdowns }>
  ) {
    console.log(data);
    this.mpDocumentNumber = data.mpDocumentNumber
    this.loggedInUsername = data.loggedInUsername
    this.CE = data.CE;
    this.workflowId = data.workflowId;
    this.isLoading = false;

    // get name of CE
    this.store.select('dp').pipe(takeUntil(this.destroy$)).subscribe((dp) => {
      if (this.CE) {
        this.currentCE = dp.UserList.find((user)=> user.id == this.CE) as DropDownOptions
      }
    })
  }

  async ngOnInit(): Promise<void> {
    await this.getCE()

  }
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  close() {
    this.isErr = false;
    this.dialogInfoRef.close();
  }

  async getCE() {
    try {
      let data : ContractExecutive = await lastValueFrom(this.BackendApi.getContractExecutive())
      this.CEList = data.ContractExecutives;
    } catch (e) {
      this.isErr = true;
      this.errorMessage = e as string;
    }
  }


  async updateAssignedCE() {
    // api call
    try {
      this.isLoading = true;
      if(!this.selectedCE) throw "Please select an Contracting Executive"
      let dataToSend = {
        purchaseID: this.mpDocumentNumber,
        actioner: this.loggedInUsername,
        user_decision: this.selectedCE?.id,
        workflowId: this.workflowId
      }
      console.log(dataToSend)
      await lastValueFrom(this.BackendApi.assignCE(dataToSend))
      this.openSnackBar("Contracting Executive assigned successfully");
      this.close();
      this.reload();
    }
    catch (e) {
      this.isErr = true
      if (e) {
        this.errorMessage = e as string;
      } else {
        this.errorMessage = "Backend Error";
      }
    } finally {
      this.isLoading = false;
    }

  }

  openSnackBar(notifMsg: string, type: string = 'success') {
    this._snackBar.open(notifMsg, undefined, {
      verticalPosition: 'top',
      panelClass: type == 'success' ? 'snackbar-popup' : 'app-notification-error',
      duration: 5000,
    });

  }

  reload() {
    let orginalUrl = this.router.url
        this.router
      .navigateByUrl('/redirect', { skipLocationChange: true })
      .then(() => {
        this.router.navigateByUrl(orginalUrl);
      });
  }


}
